import script from "./test.vue?vue&type=script&setup=true&lang=js"
export * from "./test.vue?vue&type=script&setup=true&lang=js"

import "@/assets/common.css?vue&type=style&index=0&lang=css&external"
import "./test.vue?vue&type=style&index=1&id=3d2a44bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d2a44bc"]])

export default __exports__